<template>
	<v-list-item
		link
		:to="item.route"
		@click="$emit('click')"
		:disabled="!permissions.actions[item.action_name] || item.disabled"
		:dense="dense"
	>
		<v-list-item-icon v-if="item.icon">
			<v-icon v-text="item.icon" :color="color"></v-icon>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title class="py-1" v-text="item.text"></v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>
<script>
import baseBeeComponent from "../../baseBeeComponent.js";
export default {
	mixins: [baseBeeComponent],
	props: ["item", "color", "dense"],
	name: "bee-list-item"
};
</script>